import Api from "@/api/Api";
import { API_BASE_PATH } from "@/utils/api-base-path";

const options = {
  basePath: API_BASE_PATH,
};

const ApiClient = new Api(options);

export default ApiClient;
